import { JOB_LISTING_STATE } from '~/features/xstateSystem';
import { createListingStepMachine } from '../../../step-machine/listingStep.machine';
import { API_CALLS } from './api';
import { CompensationFormValues } from './types';

export const compensationMachine = createListingStepMachine<CompensationFormValues>(
  API_CALLS.patch,
  JOB_LISTING_STATE
);
